import Vue from "vue";
import VueRouter from "vue-router";

if (process.env.NODE_ENV === "development") {
    Vue.use(VueRouter);
}

import { ROUTER_MODE } from "../config/app";

import Home from "../views/home/index.vue";

// 管理组相关
// import adminRouter from "../views/userManage/admin/router.vue";
// import authAdmin from "../views/userManage/admin/authAdmin.vue";
// import authRole from "../views/userManage/admin/authRole.vue";
// import authPermissionRule from "../views/userManage/admin/authPermissionRule.vue";


// 用户管理  -- （应用下的用户管理）
// import customerRouter from "../views/userManage/customer/router.vue";
import normalUsersAdmin from "../views/userManage/customer/normalUsersAdmin.vue";
import normalUserDetail from "../views/userManage/customer/normalUserDetails.vue";

// 消息管理
import messageList from "../views/messageManage/messageList";
import messageDetail from "../views/messageManage/messageDetail";


// 回收站管理
// import recycleRouter from "../views/integral/main.vue";
import recycleList from "../views/recycle/recycleList";

// 观点显示管理
import cateSwitchList from "../views/cateSwitch/cateSwitchList";

// 观点管理（审核）
// import cateExamineList from "../views/cateExamine/cateExamineList";
import cateExamineCommentList from "../views/cateExamine/cateExamineCommentList";

// 观点审核（改版）
import findCommentExamineList from "../views/findCommentExamine/findCommentExamineList";

import weightList from "../views/weight/weightList";

// 标签管理
import tagManager from "../views/tagManager/index";
// import tagEdit from "../views/tagManager/edit";
import homeTag from "../views/tagManager/hometag";

// 开屏动画管理
import openScreen from "../views/openScreen/openScreenList";
import openScreenAdd from "../views/openScreen/openScreenAdd";

// 开屏图片管理
import openScreenNew from "../views/openScreenNew/openScreenList";
import openScreenAddNew from "../views/openScreenNew/openScreenAdd";

// 文章管理
import findRouter from "../views/integral/main.vue";
import findList from "../views/findManage/findList";
import findAdd from "../views/findManage/findAdd";
import findVideoList from "../views/findManage/findVideoList";
import findVideoAdd from "../views/findManage/findVideoAdd";

// 财富2.1 新增 用户Plus 及 主编入口  ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
import findUserList from "../views/findManage/findUserList";
import findUserAdd from "../views/findManage/findUserAdd";

import findEditorList from "../views/findManage/findEditorList";
import findEditorAdd from "../views/findManage/findEditorAdd";
// 财富2.1 新增 用户Plus 及 主编入口  ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑

// 广告
// import advertRouter from "../views/integral/main.vue";
import advertList from "../views/findManage/advertList";
import advertAdd from "../views/findManage/advertAdd";
// import findDetail from "../views/findManage/findDetail";
import advertStats from "../views/findManage/advertStats";


const err401 = r =>
    require.ensure([], () => r(require("../views/error/err401.vue")), "home");
const err404 = r =>
    require.ensure([], () => r(require("../views/error/err404.vue")), "home");
const login = r =>
    require.ensure([], () => r(require("../views/login/index.vue")), "home");
const main = r =>
    require.ensure([], () => r(require("../views/home/main.vue")), "home");

// 注意 权限字段 authRule （严格区分大小写）
export const constantRouterMap = [
    {
        path: "*",
        component: err404,
        hidden: true
    },
    {
        path: "/401",
        component: err401,
        name: "401",
        hidden: true
    },
    {
        path: "/404",
        component: err404,
        name: "404",
        hidden: true
    },
    {
        path: "/500",
        component: err404,
        name: "500",
        hidden: true
    },
    {
        path: "/login",
        component: login,
        name: "登录",
        hidden: true
    },
    {
        path: "/",
        component: Home,
        redirect: "/readme",
        name: "首页",
        hidden: true
    },
    {
        path: "/readme",
        component: Home,
        redirect: "/readme/main",
        icon: "shouye",
        name: "首页",
        noDropdown: true,
        children: [
            {
                path: "main",
                component: main
            }
        ]
    }
];

export default new VueRouter({
    // mode: 'history', //后端支持可开
    mode: ROUTER_MODE,
    routes: constantRouterMap,
    strict: process.env.NODE_ENV !== "production"
});

export const asyncRouterMap = [
    // 用户管理
    // {
    //     path: "/userManage",
    //     redirect: "/userManage/adminManage/ ",
    //     component: Home,
    //     icon: "baimingdanguanli",
    //     name: "用户管理",
    //     meta: {
    //         authRule: ["user_manage"]
    //     },
    //     children: [
    //         // {
    //         //     path: "/userManage/adminManage",
    //         //     component: adminRouter,
    //         //     redirect: "/userManage/authAdmin/index",
    //         //     name: "管理组",
    //         //     icon: "0",
    //         //     meta: {
    //         //         authRule: ["user_manage/admin_manage"]
    //         //     },
    //         //     children: [
    //         //         {
    //         //             path: "authAdmin",
    //         //             component: authAdmin,
    //         //             name: "管理员管理",
    //         //             icon: "0",
    //         //             meta: {
    //         //                 authRule: ["admin/auth.admin/index"]
    //         //             }
    //         //         },
    //         //         {
    //         //             path: "authRole",
    //         //             component: authRole,
    //         //             name: "角色管理",
    //         //             icon: "0",
    //         //             meta: {
    //         //                 authRule: ["admin/auth.role/index"]
    //         //             }
    //         //         },
    //         //         {
    //         //             path: "authPermissionRule",
    //         //             component: authPermissionRule,
    //         //             name: "权限管理",
    //         //             icon: "0",
    //         //             meta: {
    //         //                 authRule: ["admin/auth.permission_rule/index"]
    //         //             }
    //         //         }
    //         //     ]
    //         // },
    //         {
    //             path: "/userManage/customerManage",
    //             component: customerRouter,
    //             // redirect: "/userManage/customerManage/normalUsers",
    //             name: "站内用户管理",
    //             icon: "0",
    //             meta: {
    //                 authRule: ["user_manage/customer_manage"]
    //             },
    //             children: [
    //                 {
    //                     path: "/userManage/customerManage/normalUsers",
    //                     component: customerRouter,
    //                     name: "用户管理",
    //                     icon: "0",
    //                     noDropdown: true,
    //                     meta: {
    //                         authRule: ["admin/app.users/normalusers", "admin/app.users/index", "admin/app.users/user"]
    //                     },
    //                     children: [
    //                         {
    //                             path: "",
    //                             component: normalUsersAdmin,
    //                             name: "用户列表",
    //                             icon: "0",
    //                             meta: {
    //                                 authRule: ["admin/app.users/index"]
    //                             },
    //                         },
    //                         {
    //                             path: ":id",
    //                             component: normalUserDetail,
    //                             name: "用户详情",
    //                             icon: "0",
    //                             noDropDown: true,
    //                             meta: {
    //                                 authRule: ["admin/app.users/user"]
    //                             },
    //                         }
    //                     ]
    //                 },
    //                 // {
    //                 //     path: "/userManage/customerManage/doctorUsers",
    //                 //     component: customerRouter,
    //                 //     name: "医生管理",
    //                 //     icon: "0",
    //                 //     meta: {
    //                 //         authRule: ["admin/app.users/doctorusers", "admin/app.users/index", "admin/app.users/user"]
    //                 //     },
    //                 //     noDropdown: true,
    //                 //     children: [
    //                 //         {
    //                 //             path: "",
    //                 //             component: doctorUsersAdmin,
    //                 //             name: "医生列表",
    //                 //             icon: "0",
    //                 //             meta: {
    //                 //                 authRule: ["admin/app.users/index"]
    //                 //             },
    //                 //         },
    //                 //         {
    //                 //             path: "jobDesc/:id",
    //                 //             name: "医生简历",
    //                 //             component: doctorUserJobDesc,
    //                 //             icon: "0",
    //                 //             meta: {
    //                 //                 authRule: ['admin/app.users/jobdesc']
    //                 //             }
    //                 //         },
    //                 //         {
    //                 //             path: ":id",
    //                 //             component: doctorUserDetail,
    //                 //             name: "医生详情",
    //                 //             icon: "0",
    //                 //             meta: {
    //                 //                 authRule: ["admin/app.users/user", "admin/app.users/relationproduct", "admin/app.users/audituser"]
    //                 //             },
    //                 //             children: [
    //                 //             ]
    //                 //         }
    //                 //     ]
    //                 // }
    //             ]
    //         }
    //     ]
    // },
    {
        path: "/userManage/customerManage/normalUsers",
        component: Home,
        icon: "baimingdanguanli",
        name: "用户管理",
        noDropdown: true,
        meta: {
            authRule: ["admin/app.users/normalusers", "admin/app.users/index", "admin/app.users/user"]
        },
        children: [
            {
                path: "",
                component: normalUsersAdmin,
                name: "用户列表",
                icon: "0",
                meta: {
                    authRule: ["admin/app.users/index"]
                },
            },
            {
                path: ":id",
                component: normalUserDetail,
                name: "用户详情",
                icon: "0",
                noDropDown: true,
                meta: {
                    authRule: ["admin/app.users/user"]
                },
            }
        ]
    },
    {
        path: "/tagManager",
        redirect: "/tagManager/index",
        component: Home,
        icon: "moban",
        name: "标签管理",
        noDropdown: false,
        meta: {
            authRule: ["apply_manage"]
        },
        children: [
            {
                path: "index",
                // redirect: "/tagManager/index",
                component: tagManager,
                name: "标签列表列表",
                icon: "0",
                noDropdown: true,
                meta: {
                    authRule: ["admin/tag.tag/index"]
                }
            },
            {
                path: "hometag",
                // redirect: "/tagManager/index",
                component: homeTag,
                name: "首页标签管理",
                icon: "0",
                noDropdown: true,
                meta: {
                    authRule: ["admin/tag.tag/hometag"]
                }
            }
        ]
    },
    // 文章
    {
        path: "/findManage",
        // redirect: "/consultation/ ",
        component: Home,
        icon: "jpgwenjian",
        name: "文章管理",
        meta: {
            authRule: ["findMessage"]
        },
        children: [
            {
                path: "/findManage/findList",
                // redirect: "/findMessage/findList",
                component: findRouter,
                icon: "shenjiguanli",
                name: "文章管理",
                meta: {
                    authRule: ["message_manage"]
                },
                noDropdown: true,
                children: [
                    {
                        path: "",
                        component: findList,
                        name: "",
                        icon: "0",
                        meta: {
                            authRule: ["admin/find.Find/findList"]
                        }
                    },
                    {
                        path: "/findManage/findAdd/find_id/:find_id",
                        component: findAdd,
                        name: "发布/编辑 文章/视频",
                        icon: "0",
                        meta: {
                            authRule: ["admin/find.Find/findCeate"]
                        }
                    }
                ]
            },
            {
                path: "/findManage/findVideoList",
                // redirect: "/findMessage/findList",
                component: findRouter,
                icon: "shenjiguanli",
                name: "视频管理",
                meta: {
                    authRule: ["message_manage"]
                },
                noDropdown: true,
                children: [
                    {
                        path: "",
                        component: findVideoList,
                        name: "",
                        icon: "0",
                        meta: {
                            authRule: ["admin/find.Find/findVideoList"]
                        }
                    },
                    {
                        path: "/findManage/findVideoAdd/find_id/:find_id",
                        component: findVideoAdd,
                        name: "发布/编辑 文章/视频",
                        icon: "0",
                        meta: {
                            authRule: ["admin/find.Find/findVideoAdd"]
                        }
                    }
                ]
            },
            {
                path: "/findManage/findUserList",
                // redirect: "/findMessage/findUserList",
                component: findRouter,
                icon: "shenjiguanli",
                name: "用户Plus内容",
                meta: {
                    authRule: ["message_manage"]
                },
                noDropdown: true,
                children: [
                    {
                        path: "",
                        component: findUserList,
                        name: "",
                        icon: "0",
                        meta: {
                            authRule: ["admin/find.Find/findUserList"]
                        }
                    },
                    {
                        path: "/findManage/findUserAdd/find_id/:find_id",
                        component: findUserAdd,
                        name: "发布/编辑 文章/视频",
                        icon: "0",
                        meta: {
                            authRule: ["admin/find.Find/findCeate"]
                        }
                    }
                ]
            },
            {
                path: "/findManage/findEditorList",
                // redirect: "/findMessage/findList",
                component: findRouter,
                icon: "shenjiguanli",
                name: "推荐给主编",
                meta: {
                    authRule: ["message_manage"]
                },
                noDropdown: true,
                children: [
                    {
                        path: "",
                        component: findEditorList,
                        name: "",
                        icon: "0",
                        meta: {
                            authRule: ["admin/find.Find/findEditorList"]
                        }
                    },
                    {
                        path: "/findManage/findEditorAdd/find_id/:find_id",
                        component: findEditorAdd,
                        name: "发布/编辑 文章/视频",
                        icon: "0",
                        meta: {
                            authRule: ["admin/find.Find/findCeate"]
                        }
                    }
                ]
            },
        ]
    },
    // 文章管理
    // {
    //     path: "/findMessage",
    //     redirect: "/findMessage/findList",
    //     component: Home,
    //     icon: "shenjiguanli",
    //     name: "文章管理",
    //     meta: {
    //         authRule: ["message_manage"]
    //     },
    //     noDropdown: true,
    //     children: [
    //         {
    //             path: "findList",
    //             component: findList,
    //             name: "文章管理",
    //             icon: "0",
    //             meta: {
    //                 authRule: ["admin/find.Find/findList"]
    //             }
    //         },
    //         {
    //             path: "/findManage/findAdd/find_id/:find_id",
    //             component: findAdd,
    //             name: "发布/编辑 文章/视频",
    //             icon: "0",
    //             meta: {
    //                 authRule: ["admin/find.Find/findCeate"]
    //             }
    //         }
    //     ]
    // },
   
    // 消息管理
    {
        path: "/messageManage",
        redirect: "/messageManage/messageList",
        component: Home,
        icon: "yewuzixun",
        name: "消息管理",
        meta: {
            authRule: ["message_manage"]
        },
        noDropdown: true,
        children: [
            {
                path: "messageList",
                component: messageList,
                name: "消息列表",
                icon: "0",
                meta: {
                    authRule: ["admin/notification.notification/notificationlist"]
                }
            },
            {
                path: "messageDetail",
                component: messageDetail,
                name: "消息详情",
                icon: "0",
                meta: {
                    authRule: ["admin/notification.notification/notificationlist"]
                }
            },
        ]
    },
    // 观点管理（审核）
    // {
    //     path: "/cateExamine",
    //     redirect: "/cateExamine/cateExamineList",
    //     component: Home,
    //     icon: "heguiqushi",
    //     name: "观点管理（审核）",
    //     meta: {
    //         authRule: ["message_manage"]
    //     },
    //     noDropdown: true,
    //     children: [
    //         {
    //             path: "cateExamineList",
    //             component: cateExamineList,
    //             name: "观点管理",
    //             icon: "0",
    //             meta: {
    //                 authRule: ["admin/app.Users/cateExamineList"]
    //             }
    //         },
    //         {
    //             path: "/cateExamine/cateExamineCommentList/find_id/:find_id",
    //             component: cateExamineCommentList,
    //             name: "观点列表",
    //             icon: "0",
    //             meta: {
    //                 authRule: ["admin/app.Users/cateExamine"]
    //             }
    //         }
    //     ]
    // },
    // 观点管理（审核改版）
    {
        path: "/findCommentExamine",
        redirect: "/findCommentExamine/findCommentExamine",
        component: Home,
        icon: "heguiqushi",
        name: "观点管理（审核）",
        meta: {
            authRule: ["message_manage"]
        },
        noDropdown: true,
        children: [
            {
                path: "findCommentExamine",
                component: findCommentExamineList,
                name: "观点管理",
                icon: "0",
                meta: {
                    authRule: ["admin/app.Users/cateExamineList"]
                }
            },
            {
                path: "/cateExamine/cateExamineCommentList/find_id/:find_id",
                component: cateExamineCommentList,
                name: "观点列表",
                icon: "0",
                meta: {
                    authRule: ["admin/app.Users/cateExamine"]
                }
            }
        ]
    },
    // 广告管理
    // {
    //     path: "/advertList",
    //     // redirect: "/consultation/ ",
    //     component: Home,
    //     icon: "jpgwenjian",
    //     name: "广告管理",
    //     meta: {
    //         authRule: ["findMessage"]
    //     },
    //     children: [
    //         {
    //             path: "/advertList",
    //             component: advertRouter,
    //             icon: "shenjiguanli",
    //             name: "广告管理",
    //             meta: {
    //                 authRule: ["message_manage"]
    //             },
    //             noDropdown: true,
    //             children: [
    //                 {
    //                     path: "advertList",
    //                     component: advertList,
    //                     name: "",
    //                     icon: "0",
    //                     meta: {
    //                         authRule: ["admin/find.Find/findList"]
    //                     }
    //                 },
    //                 // {
    //                 //     path: "/findManage/advertStats/find_id/:find_id",
    //                 //     component: advertStats,
    //                 //     name: "数据管理",
    //                 //     icon: "0",
    //                 //     meta: {
    //                 //         authRule: ["admin/find.Find/advertStats"]
    //                 //     }
    //                 // },
    //                 {
    //                     path: "/findManage/advertAdd/find_id/:find_id",
    //                     component: advertAdd,
    //                     name: "发布/编辑 广告文章/视频",
    //                     icon: "0",
    //                     meta: {
    //                         authRule: ["admin/find.Find/findCeate"]
    //                     }
    //                 }
    //             ]
    //         },
    //         {
    //             path: "/findMessage",
    //             // redirect: "/findMessage/findList",
    //             component: findRouter,
    //             icon: "shenjiguanli",
    //             name: "数据统计",
    //             meta: {
    //                 authRule: ["message_manage"]
    //             },
    //             noDropdown: true,
    //             children: [
    //                 {
    //                     path: "findVideoList",
    //                     component: findVideoList,
    //                     name: "数据统计",
    //                     icon: "0",
    //                     meta: {
    //                         authRule: ["admin/find.Find/findVideoList"]
    //                     }
    //                 },
    //                 {
    //                     path: "/findManage/findVideoAdd/find_id/:find_id",
    //                     component: findVideoAdd,
    //                     name: "发布/编辑 文章/视频",
    //                     icon: "0",
    //                     meta: {
    //                         authRule: ["admin/find.Find/findVideoAdd"]
    //                     }
    //                 }
    //             ]
    //         },
    //     ]
    // },
    // 广告管理
    {
        path: "/advertList",
        redirect: "",
        component: Home,
        icon: "renwuguanli",
        name: "广告管理",
        meta: {
            authRule: ["message_manage"]
        },
        noDropdown: true,
        children: [
            {
                path: "advertList",
                component: advertList,
                name: "广告管理",
                icon: "0",
                meta: {
                    authRule: ["admin/find.Find/findList"]
                }
            },
            {
                path: "/findManage/advertAdd/find_id/:find_id",
                component: advertAdd,
                name: "发布/编辑 文章/视频",
                icon: "0",
                meta: {
                    authRule: ["admin/find.Find/findVideoAdd"]
                }
            },
            {
                path: "/findManage/advertStats/find_id/:find_id",
                component: advertStats,
                name: "数据管理",
                icon: "0",
                meta: {
                    authRule: ["admin/find.Find/advertStats"]
                }
            },
        ]
    },
    // 回收站管理
    {
        path: "/recycle",
        redirect: "/recycle/recycleList",
        component: Home,
        icon: "renwuguanli",
        name: "回收站管理",
        meta: {
            authRule: ["message_manage"]
        },
        noDropdown: true,
        children: [
            {
                path: "recycleList",
                component: recycleList,
                name: "回收站列表",
                icon: "0",
                meta: {
                    authRule: ["admin/recycle.Recycle/RecycleList"]
                }
            }
        ]
    },
    // 开屏动画管理
    {
        path: "/openScreen",
        redirect: "/openScreen/openScreenList",
        component: Home,
        icon: "gaojingqingchuguize",
        name: "开屏动画管理",
        meta: {
            authRule: ["message_manage"]
        },
        noDropdown: true,
        children: [
            {
                path: "openScreen",
                component: openScreen,
                name: "开屏动画管理",
                icon: "0",
                meta: {
                    authRule: ["admin/app.Users/dzTagList"]
                }
            },
            {
                path: "/openScreen/openScreenAdd/cate_id/:cate_id",
                component: openScreenAdd,
                name: "开屏动画添加/修改",
                icon: "0",
                meta: {
                    authRule: ["admin/app.Users/openScreen","admin/app.Users/openScreenUpd"]
                }
            }
        ]
    },
    // 开屏图片管理
    {
        path: "/openScreenNew",
        redirect: "/openScreenNew/openScreenNew",
        component: Home,
        icon: "gaojingqingchuguize",
        name: "开屏图片管理",
        meta: {
            authRule: ["message_manage"]
        },
        noDropdown: true,
        children: [
            {
                path: "openScreenNew",
                component: openScreenNew,
                name: "开屏图片管理",
                icon: "0",
                meta: {
                    authRule: ["admin/app.Users/dzTagList"]
                }
            },
            {
                path: "/openScreenNew/openScreenAdd/screen_id/:screen_id",
                component: openScreenAddNew,
                name: "开屏图片添加/修改",
                icon: "0",
                meta: {
                    authRule: ["admin/app.Users/openScreen","admin/app.Users/openScreenUpd"]
                }
            }
        ]
    },
     // 观点显示管理
     {
        path: "/cateSwitch",
        redirect: "/cateSwitch/cateSwitchList",
        component: Home,
        icon: "baocunbingxiayibu",
        name: "观点显示管理",
        meta: {
            authRule: ["message_manage"]
        },
        noDropdown: true,
        children: [
            {
                path: "cateSwitchList",
                component: cateSwitchList,
                name: "观点列表",
                icon: "0",
                meta: {
                    authRule: ["admin/cateSwitch.cateSwitch/cateSwitchList"]
                }
            }
        ]
    },
    // 排序权重配置
     {
        path: "/weightList",
        redirect: "/weight/weightList",
        component: Home,
        icon: "baocunbingxiayibu",
        name: "排序权重配置",
        meta: {
            authRule: ["message_manage"]
        },
        noDropdown: true,
        children: [
            {
                path: "weightList",
                component: weightList,
                name: "权重配置",
                icon: "0",
                meta: {
                    authRule: ["admin/find/Find/WeightList"]
                }
            }
        ]
    },
    // 系统管理
    // {
    //     path: "/systemManage",
    //     component: Home,
    //     icon: "xitong",
    //     name: "系统管理",
    //     meta: {
    //         authRule: ["system_manage"]
    //     },
    //     children: [
    //         {
    //             path: "stationmessagemanage",
    //             component: stationmessagemanage,
    //             name: "站内信管理",
    //             icon: "0",
    //             meta: {
    //                 authRule: ["system_message"]
    //             }
    //         },
    //         {
    //             path: "app-version",
    //             component: appVersion,
    //             name: "版本更新",
    //             icon: "0",
    //             meta: {
    //                 authRule: ["admin/app.version/create"]
    //             }
    //         },
    //         {
    //             path: "/systemManage/complaintmanage",
    //             component: complaintRouter,
    //             name: "投诉管理",
    //             icon: "0",
    //             meta: {
    //                 authRule: ["system_complaint"]
    //             },
    //             redirect: "/systemManage/complaintmanage",
    //             noDropdown: true,
    //             children: [
    //                 {
    //                     path: "",
    //                     component: complaintManage,
    //                     name: "投诉管理",
    //                     icon: "0",
    //                     meta: {
    //                         authRule: ["admin/system.complaint/index", "admin/system.complaint/activeuser"]
    //                     }
    //                 },
    //                 {
    //                     path: "view/:id",
    //                     component: complaintView,
    //                     name: "投诉查看",
    //                     icon: "0",
    //                     meta: {
    //                         authRule: ["admin/app.users/user", "admin/system.complaint/user2complain"]
    //                     }
    //                 }
    //             ]
    //         },
    //         {
    //             path: "customer-service-staff",
    //             component: customerServiceStaff,
    //             name: "客服管理",
    //             icon: "0",
    //             meta: {
    //                 authRule: ["admin/system.customer_service_staff/index", "admin/system.customer_service_staff/create", "admin/system.customer_service_staff/delete", "admin/app.users/index"]
    //             }
    //         }
    //     ]
    // },
    // 三方文章管理
    // {
    //     path: "/article",
    //     redirect: "/article/article",
    //     component: Home,
    //     icon: "wordwenjian",
    //     name: "文章管理",
    //     meta: {
    //         authRule: ["article/auth/index"]
    //     },
    //     noDropdown: true,
    //     children: [
    //         {
    //             path: "",
    //             component: article
    //         }
    //     ]
    // },
    // 文本管理
    // {
    //     path: "/texts",
    //     redirect: "/texts/texts",
    //     component: Home,
    //     icon: "txtwenjian",
    //     name: "文本管理",
    //     meta: {
    //         authRule: ["text_manage"]
    //     },
    //     noDropdown: true,
    //     children: [
    //         {
    //             path: "",
    //             component: tests
    //         }
    //     ]
    // },
    // //会诊管理
    // {
    //     path: "/group",
    //     component: Home,
    //     redirect: "/group/groupList",
    //     icon: "dingdan",
    //     name: "会诊管理",
    //     meta: {
    //         authRule: ["group_manage"]
    //     },
    //     noDropdown: true,
    //     children: [
    //         {
    //             path: "groupList",
    //             component: groupList,
    //             name: "会诊列表",
    //             icon: "0",
    //             meta: {
    //                 authRule: ["admin/group.group/grouplist"]
    //             }
    //         },
    //         {
    //             path: "groupDetail",
    //             component: groupDetail,
    //             name: "会诊详情",
    //             hidden: true,
    //             meta: {
    //                 authRule: ["admin/group.group/groupdetail"]
    //             }
    //         },
    //     ]
    // },



];
